import { useEffect, useState } from "react";

type ColorMode = "light" | "dark";

const readMode = (): ColorMode =>
  document.documentElement.getAttribute("data-theme") === "light"
    ? "light"
    : "dark";

/**
 * Tracks the app's active color mode, which is stored as `data-theme` on
 * `<html>` (set in the Rails layout and toggled by the settings modal). The
 * app defaults to dark when the attribute is absent.
 *
 * Use this to keep a third-party theme provider (e.g. Astryx's `<Theme>`) in
 * sync with the app's own light/dark toggle so the two don't fight over
 * `<html>`.
 */
export const useDocumentTheme = (): ColorMode => {
  const [mode, setMode] = useState<ColorMode>(readMode);

  useEffect(() => {
    const observer = new MutationObserver(() => setMode(readMode()));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  return mode;
};
